<template>
<div>
  
  <h4 v-if="doc.documentId">
    <i  class="fas fa-store mr-2" aria-hidden="true"></i>
    {{doc.store}}   -   
    
      <strong>  {{doc.supplier}} </strong>   -
       <i class="fas fa-file-alt mr-2" aria-hidden="true"></i>
      <strong> {{doc.description}} </strong>  n.ro <strong> {{doc.number}} </strong>  del  <strong> 
     {{doc.date }}
       
       </strong>  
  </h4>
  <h4  v-else> {{item.store}} - {{item.name}} -  {{item.typeId == 1 ? 'FATTURA':'DDT' }} n.ro {{item.number}} del  
        {{
       new Date(item.date).toLocaleDateString('it-IT',{ year: 'numeric', month: '2-digit', day: '2-digit' })
       }}
        
  </h4>      

</div>
</template>
<script>

//import api                 from '@/api';

export default {
   

  props  : ['doc','item'],
  data () 
  {
    return {

 // doc : {}

    }
    
    },


   created () 
    {
      
        //this.getData()
     
    },
  methods: {

    
  }
}
</script>

<style scoped>
 h4 {
  font-family : 'Roboto Condensed';
  font-size   : 26px;
  color       : brown
   }
</style>
